/*
 * Floretta cutoff bar (sections/floretta-cutoff-bar.liquid): the time left to order for
 * same-day delivery, in Vancouver time. After the cutoff, or on a closed day, the next
 * delivery day. Refreshes every 30 seconds.
 */
(() => {
  if (customElements.get("floretta-cutoff-bar")) return;

  const TIME_ZONE = "America/Vancouver";

  // Now in Vancouver: the date as YYYY-MM-DD and the minutes since midnight.
  const vancouverNow = () => {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat("en-CA", {
        timeZone: TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", hourCycle: "h23",
      }).formatToParts(new Date()).map((part) => [part.type, part.value])
    );
    return { date: `${parts.year}-${parts.month}-${parts.day}`, minutes: Number(parts.hour) * 60 + Number(parts.minute) };
  };
  const addDays = (ymd, days) => new Date(Date.parse(`${ymd}T00:00:00Z`) + days * 86400000).toISOString().slice(0, 10);
  const weekday = (ymd) => new Date(`${ymd}T00:00:00Z`).toLocaleDateString("en-CA", { weekday: "long", timeZone: "UTC" });
  const longDate = (ymd) =>
    new Date(`${ymd}T00:00:00Z`).toLocaleDateString("en-CA", { weekday: "long", month: "long", day: "numeric", timeZone: "UTC" });

  class FlorettaCutoffBar extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector("[data-cutoff-text]");
      this.cutoff = Number(this.dataset.cutoffHour || 17) * 60;
      this.closed = new Set((this.dataset.closedDates || "").split(",").map((d) => d.trim()).filter(Boolean));
      this.render();
      this.timer = setInterval(() => this.render(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    // The first open day after `from`, within the next two months.
    nextOpenDay(from) {
      for (let days = 1; days <= 60; days++) {
        const day = addDays(from, days);
        if (!this.closed.has(day)) return { day, days };
      }
      return null;
    }

    render() {
      if (!this.text) return;
      const now = vancouverNow();
      const openToday = !this.closed.has(now.date);

      if (openToday && now.minutes < this.cutoff) {
        const left = this.cutoff - now.minutes;
        const hours = Math.floor(left / 60);
        const minutes = left % 60;
        const time = hours > 0 ? `${hours} h ${String(minutes).padStart(2, "0")} min` : `${minutes} min`;
        this.text.innerHTML = `Order in the next <strong>${time}</strong> for same-day delivery`;
        return;
      }

      const next = this.nextOpenDay(now.date);
      if (!next) return;
      const when = next.days === 1 ? "tomorrow" : next.days < 7 ? weekday(next.day) : longDate(next.day);
      const lead = openToday ? "Order now" : "We're closed today. Order now";
      this.text.innerHTML = `${lead} for delivery <strong>${when}</strong>`;
    }
  }

  customElements.define("floretta-cutoff-bar", FlorettaCutoffBar);
})();
